import React from 'react'
import cx from 'classnames'
import Stepper from './Stepper'
import WaiterStepperItemContainer from './../containers/components/WaiterStepperItem'
import { STEPPER_MAX } from '../constants/app'

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import brown from '@material-ui/core/colors/brown';

class WaiterStepper extends Stepper {
  handleItemOnClick = (params) => {
    const {
      isStepper,
      category,
      menuId,
      itemId,
      name,
      price,
      itemGroups,
      currentQty,
      discount,
      setStep,
      priceUndetermined,
      isIncrement,
      increaseAmount,
    } = params
    if (isIncrement) {
      this.handleStepperOnChange(
        isStepper,
        category,
        menuId,
        itemId,
        name,
        price,
        itemGroups,
        currentQty,
        discount,
        setStep,
        priceUndetermined,
        isIncrement,
        increaseAmount,
        true, // useStepperValue
      )(this.regulateIncreaseQty(currentQty, increaseAmount))
    } else {
      this.handleStepperOnChange(
        isStepper,
        category,
        menuId,
        itemId,
        name,
        price,
        itemGroups,
        currentQty,
        discount,
        setStep,
        priceUndetermined,
        isIncrement,
        increaseAmount,
        true, // useStepperValue
      )(this.regulateDecreaseQty(currentQty, increaseAmount))
    }
  }

  regulateIncreaseQty = (currentQty, increaseAmount) => {
    const { waiter } = this.props
    if (waiter.numberPad.value) {
      const value = Number(waiter.numberPad.value)
      return value > STEPPER_MAX ? STEPPER_MAX : currentQty + increaseAmount
    }
    return currentQty === STEPPER_MAX ? STEPPER_MAX : currentQty + increaseAmount
  }

  regulateDecreaseQty = (currentQty, increaseAmount) => {
    const { waiter } = this.props
    if (waiter.numberPad.value) {
      return currentQty + increaseAmount
    }
    return currentQty - 1
  }

  renderWaiterStepperItem = (commodity, menuId, itemId, name, stepMin, stepMax, stepQuantity, itemMax, category, price, itemGroups, currentQty, discount, setStep, priceUndetermined, sold, customizedCode) => {
    const { waiter } = this.props
    const defaultParams = {
      isStepper: true,
      category,
      menuId,
      itemId,
      name,
      price,
      itemGroups,
      currentQty,
      discount,
      setStep,
      priceUndetermined,
    }

    let shouldShowOverlay = false

    if (stepMax !== 0) {
      if (stepQuantity >= stepMax) {
        if (currentQty === 0) {
          shouldShowOverlay = true
        }
      }
    }

    return (
      <WaiterStepperItemContainer
        commodity={commodity}
        setStep={setStep}
        itemId={itemId}
        name={name}
        price={price}
        currentQty={currentQty}
        discount={discount}
        priceUndetermined={priceUndetermined}
        onAddBtnClick={() => {
          const isNoNeedFirstClick = (stepMax === 0 && itemMax === undefined && currentQty === 0)
          const isNotRequired = itemId.startsWith('0-') // > 套餐內的 '不需要' 品項
          const isSet = Boolean(stepMax || stepMin)

          if (priceUndetermined) {
            this.setState({ showDialog: true })
            return null
          }

          if (
            (stepQuantity < stepMax && (itemMax === 0 || currentQty < itemMax)) ||
            (stepMax === undefined && itemMax === undefined) || // > 非套餐的一般品項不會有 step && max
            (stepMax === 0 && itemMax === 0) ||
            isNoNeedFirstClick ||
            (isNotRequired && stepQuantity < 1) // > 套餐內的 '不需要' 品項僅能點一次（仿照客人版的行為模式）
          ) {
            if (waiter.numberPad.value) {
              // Use multiple increament only for non set item.
              if (!isSet) {
                // If both current and numberPad quantity are 0, do nothing.
                if (currentQty === 0 && Number(waiter.numberPad.value) === 0) return

                const increaseAmount = Number(waiter.numberPad.value) - currentQty
                const resetQty = currentQty + increaseAmount === 0
                if (Number(waiter.numberPad.value) <= STEPPER_MAX) {
                  return this.handleItemOnClick({
                    ...defaultParams,
                    isIncrement: increaseAmount >= 0 && !resetQty,
                    increaseAmount: increaseAmount,
                  })
                }
              }
            }
            this.handleItemOnClick({
              ...defaultParams,
              isIncrement: true,
              increaseAmount: 1,
            })
          }
        }}
        onMinusBtnClick={() => {
          if (currentQty > 0) {
            this.handleItemOnClick({
              ...defaultParams,
              isIncrement: false,
              increaseAmount: -1,
            })
          }
        }}
        shouldShowOverlay={shouldShowOverlay}
        sold={sold}
        customizedCode={customizedCode}
      />)
  };

  render() {
    const {
      commodity,
      orders,
      classes,
      name,
      price,
      sold,
      discount,
      priceUndetermined,
      intl,
      category,
      menuId,
      itemId,
      itemGroups,
      setStep,
      stepMin,
      stepMax,
      itemMax,
      customizedCode,
    } = this.props

    const wrapStyle = cx(classes.wrap)
    const setItemPriceTitle = intl.formatMessage({ id: 'setItemPrice.title' })
    const setItemPriceText = intl.formatMessage({ id: 'setItemPrice.price' })
    const setItemPriceEnter = intl.formatMessage({ id: 'setItemPrice.enter' })
    const setItemPriceCancel = intl.formatMessage({ id: 'setItemPrice.cancel' })
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: "#614D4A",
        },
        secondary: {
          main: "#E2C663",
        },
      },
    });
    const handleClose = () => {
      this.setState({showDialog: false})
      this.setState({setPrice: 0})
    };
    const handleSubmit = () => {
      this.setState({showDialog: false})
      document.getElementById(name).click()
    };
    const handleChange = (e) => {
      this.setState({ setPrice: Number(e.target.value) });
    };

    const currentQty = orders.reduce((accu, order) => {
      if (!category || !category.isSet) {
        if (order.dishId === itemId) {
          if (order.steps) {
            accu = 1
          } else {
            accu += order.quantity
          }
        }
      } else {
        if ((order.dishId === category.id) && !order.confirmed) {
          const oldItem = order.items.find((item) => item.dishId === itemId)
          if (oldItem) {
            accu += oldItem.quantity
          }
        }
      }
      return accu
    }, 0)

    let stepQuantity = 0

    if (!category) {

    } else {
      stepQuantity = orders.reduce((accu, order) => {
        if ((order.dishId === category.id) && !order.confirmed) {
          return accu + order.items.reduce((accu, order) => {
            if (order.setStep.key === setStep.key) {
              return accu + order.quantity
            } else {
              return accu
            }
          }, 0)
        } else {
          return accu
        }
      }, 0)
    }

    return (
      <div id='waiter-stepper' ref={ref => { this.ref = ref }} style={{ height: '100%', width: '100%' }}>
        {this.renderWaiterStepperItem(commodity, menuId, itemId, name, stepMin, stepMax, stepQuantity, itemMax, category, this.state.setPrice > 0 ? this.state.setPrice : price, itemGroups, currentQty, discount, setStep, this.state.setPrice > 0 ? false : priceUndetermined, sold, customizedCode)}
        {
          this.renderDialogComponent() // > what dialog?
        }
        {
          this.state.isRenderBottomActionSheet && // > isRenderBottomActionShee always be false?
          <div className={wrapStyle}>{this.renderBottomSheet()}</div>
        }
        <MuiThemeProvider theme={theme}>
        <Dialog open={this.state.showDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title" color='primary'>{setItemPriceTitle}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="price"
              label={setItemPriceText}
              value={this.state.setPrice}
              onChange={handleChange}
              type="number"
              min="0"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              color='secondary'
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary'>
              {setItemPriceCancel}
            </Button>
            <Button onClick={handleSubmit} color='secondary'>
              {setItemPriceEnter}
            </Button>
          </DialogActions>
        </Dialog>
        </MuiThemeProvider>
      </div>
    )
  }
}

export default WaiterStepper



// WEBPACK FOOTER //
// ./src/components/WaiterStepper.js